module.exports = __webpack_public_path__ + "img/mast.f547f93.svg";